module.exports = __webpack_public_path__ + "img/组 127@2x.7d9f2934.png";